import * as React from "react";
import { ReactElement } from "react";
import "./LeaderboardWidget.scss";
import { LeaderboardItemProps } from "./LeaderboardWidget.types";
import { Label, Loader, SpintrUser } from "src/ui";
import classNames from "classnames";
import { HoverCard, KeyCodes, HoverCardType, IPlainCardProps } from "@fluentui/react";
import { Link } from "react-router-dom";
import { circleSmall } from "src/ui/helpers/style";

function LeaderboardItem({ item, isOnPodium, variables, isCurrentUser }: LeaderboardItemProps): ReactElement {
    const { ranking, count, provision, imageUrl, id, name } = item;

    const firstName = name ? name.split(" ")[0] : "";

    const onRenderPlainCard = (props: IPlainCardProps): ReactElement => {
        const descriptions = variables?.descriptions || [];
        const values = [];
        if (count != null) values.push(count);
        if (provision != null) {
            const formattedProvision = provision?.toLocaleString('sv-SE');
            values.push(formattedProvision);
        };
        if (ranking != null) values.push(ranking);

        const header = variables.header || "";

        if (!item) {
            return (
                <div className="LeaderboardItem-hovercard">
                    <Loader />
                </div>
            )
        }

        return (
            <div className="LeaderboardItem-hovercard">
                <div>
                    <Link to={`/profile/${id}`} className="left">
                        <SpintrUser
                            name={name}
                            imageUrl={imageUrl || ""}
                            personalName={true} />
                    </Link>
                </div>

                <div className="stat-list">
                    <div>
                        <Label
                            as="span"
                            size={"body-2"}
                            color={"dark-grey"}
                            weight={"semi-bold"}>
                            {header}
                        </Label>
                    </div>
                    {descriptions && descriptions.map((desc, index) => (
                        <div key={index} className="stat-row">
                            <Label
                                className="description"
                                as="span"
                                size="body-2"
                                color="visageGray3"
                                weight="medium">
                                {desc}
                            </Label>
                            <Label
                                className="value"
                                as="span"
                                size="body-2"
                                color="dark-grey"
                                weight="medium">
                                {values[index]}
                            </Label>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    const plainCardProps: IPlainCardProps = {
        onRenderPlainCard: onRenderPlainCard,
        renderData: item
    };

    return (
        <div className={classNames("LeaderboardItem", {
            "podium": isOnPodium,
            "gold": isOnPodium && ranking === 1,
            "silver": isOnPodium && ranking === 2,
            "bronze": isOnPodium && ranking === 3,
            "current-user": isCurrentUser
        })}>
            <HoverCard
                trapFocus
                openHotKey={KeyCodes.enter}
                plainCardProps={plainCardProps}
                instantOpenOnClick
                type={HoverCardType.plain}>
                <div className="info">
                    <div className="user-medal-container">
                        {isOnPodium && <div className="medal">{ranking === 1 ? "🥇" : ranking === 2 ? "🥈" : "🥉"}</div>}
                        <SpintrUser
                            imageUrl={imageUrl || ""}
                            name={firstName}
                            hideText={true}
                            personalName={true}
                            size={circleSmall} />
                    </div>
                    <div className="info-text">
                        <div className="ranking-circle">
                            <Label size="small-2">
                                {ranking}
                            </Label>
                        </div>
                        {isOnPodium && (
                            <Label
                                size={"body-2"}
                                color={"dark-grey"}
                                weight={"medium"}
                                className="title">
                                {firstName}
                            </Label>
                        )}
                    </div>
                </div>
            </HoverCard>
        </div>
    );
};

export default LeaderboardItem;
